// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/DataUpload.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported";

export interface DataUpload {
  numberOfFiles: number;
  sizeOfFilesGb: number;
}

function createBaseDataUpload(): DataUpload {
  return { numberOfFiles: 0, sizeOfFilesGb: 0 };
}

export const DataUpload: MessageFns<DataUpload> = {
  encode(message: DataUpload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.numberOfFiles !== 0) {
      writer.uint32(8).int32(message.numberOfFiles);
    }
    if (message.sizeOfFilesGb !== 0) {
      writer.uint32(21).float(message.sizeOfFilesGb);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataUpload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataUpload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.numberOfFiles = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.sizeOfFilesGb = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataUpload {
    return {
      numberOfFiles: isSet(object.numberOfFiles) ? globalThis.Number(object.numberOfFiles) : 0,
      sizeOfFilesGb: isSet(object.sizeOfFilesGb) ? globalThis.Number(object.sizeOfFilesGb) : 0,
    };
  },

  toJSON(message: DataUpload): unknown {
    const obj: any = {};
    if (message.numberOfFiles !== 0) {
      obj.numberOfFiles = Math.round(message.numberOfFiles);
    }
    if (message.sizeOfFilesGb !== 0) {
      obj.sizeOfFilesGb = message.sizeOfFilesGb;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataUpload>, I>>(base?: I): DataUpload {
    return DataUpload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataUpload>, I>>(object: I): DataUpload {
    const message = createBaseDataUpload();
    message.numberOfFiles = object.numberOfFiles ?? 0;
    message.sizeOfFilesGb = object.sizeOfFilesGb ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
